// extracted by mini-css-extract-plugin
export default {"emoji-text":"Emoji_emoji-text__t8+Lo","emojiText":"Emoji_emoji-text__t8+Lo"};